// extracted by mini-css-extract-plugin
export var formContainer = "_go-0";
export var message = "_go-1";